export default __webpack_public_path__ + "static/media/plain-sticker-yo.ca9f0c9e.png";